// extracted by mini-css-extract-plugin
export default {"info_nav":"styles_info_nav__0+EPL","nav_item":"styles_nav_item__yJKFL","active_indicator":"styles_active_indicator__oNOK4","divider":"styles_divider__RMgW-"};